<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon class="icon">people</mat-icon>
      Members
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
      @if (!loading) {
        &nbsp;{{ DataSource.connect().value.length }}
      }
    </h1>
  </section>
  <section mat-dialog-content>
    <search-text (search)="setSearch($event)"></search-text>
    <table mat-table [dataSource]="DataSource">
      <ng-container matColumnDef="first_name">
        <th mat-header-cell *matHeaderCellDef>First Name</th>
        <td mat-cell *matCellDef="let row">{{row.first_name }}</td>
      </ng-container>
      <ng-container matColumnDef="last_name">
        <th mat-header-cell *matHeaderCellDef>Last Name</th>
        <td mat-cell *matCellDef="let row">{{row.last_name}}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let row">{{row.email}}</td>
      </ng-container>
      <ng-container matColumnDef="branch_number">
        <th mat-header-cell *matHeaderCellDef>Branch No.</th>
        <td mat-cell *matCellDef="let row">{{row.branch_number}}</td>
      </ng-container>
      <ng-container matColumnDef="employee_number">
        <th mat-header-cell *matHeaderCellDef>Employee No.</th>
        <td mat-cell *matCellDef="let row">{{row.employee_number}}</td>
      </ng-container>
      <ng-container matColumnDef="joined">
        <th mat-header-cell *matHeaderCellDef>Joined</th>
        <td mat-cell *matCellDef="let row">{{row.joined }}</td>
      </ng-container>
      <ng-container matColumnDef="expired">
        <th mat-header-cell *matHeaderCellDef>Expires</th>
        <td mat-cell *matCellDef="let row">{{row.expires }}</td>
      </ng-container>
      <ng-container matColumnDef="membership">
        <th mat-header-cell *matHeaderCellDef>Membership</th>
        <td mat-cell *matCellDef="let row">
          <button (click)="showMemberships(row)" mat-icon-button>
            <mat-icon>people</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell message" [attr.colspan]="displayedColumns.length">
          @if (DataSource.errorMessage) {
            <span role="alert">{{ DataSource.errorMessage }}</span>
          } @else {
            No members found
          }
        </td>
      </tr>
    </table>
  </section>
  <section align="end" mat-dialog-actions>
    <button mat-button mat-dialog-close matTooltip="Cancel and close.">
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      (click)="downloadMembers()"
      [disabled]="loading || DataSource.length() <= 0"
      mat-button
      matTooltip="Download member list."
      >
      <mat-icon>save</mat-icon>
      Download
    </button>
  </section>
</section>
